const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

export const BatchProcessTrackingCommandURL = {
    RestartLlmBatch: Backofficebff + '/v1/batch-process-tracking/restart-llm-batch',
};
